module.exports = __webpack_public_path__ + "media/images/background_graphics/trust_and_safety_background_vector_tablet-768c23bb9d134b1ac8482f48e2c462c9.svg";